import React, { Fragment, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CommonSvg } from "../SVG";
import WordWrapEllipse from "./WordWrapEllipse";
import {
  DOWNLAOD_MULTIPLE_ASSET,
  downloadCollection,
} from "../../DAM_API/urls";
import Axios from "../../../utils/Axios";
import { useDownloadAssets } from "../../../context/DownloadAssetsContext";

// 'key validator design layout'
// '1 - just normal click with mouse'
// '2 - the case when the ctrl key and mouse is clicked at the time'
// '3 - the case when we click shift and click in which we will select all the previous '

const CommonCollection = ({
  Data,
  EllipseActions,
  ClickHanlde,
  Index = 0,
  isSelected,
  HandleSelect,
  HanldeTwiceClick,
}) => {
  const lastKeyPressTime = useRef(0);
  const lastKey = useRef(null);
  const navigate = useNavigate();
  const { startDownload } = useDownloadAssets();

  // Handle mouse clicks with modifier keys
  const handleMouseClick = (e) => {
    if (e.button === 0 && !e.ctrlKey && !e.shiftKey) {
      HandleSelect({
        Image: Data,
        Key: 1,
      });
    }
    if (e.shiftKey && e.button === 0) {
      HandleSelect({
        Image: Data,
        Key: 3,
      });
    }

    if (e.ctrlKey && !e.shiftKey) {
      HandleSelect({
        Image: Data,
        Key: 2,
      });
    }

    if (e.altKey) {
    }
  };

  // Handle double mouse clicks
  const handleDoubleClick = (e) => {
    // HandleSelect(Data);
    HanldeTwiceClick && HanldeTwiceClick();

    if (e.shiftKey) {
    }
  };

  // Handle keyboard keys like Shift + Enter + detect double presses
  const handleKeyDown = (e) => {
    const now = Date.now();

    if (e.shiftKey && e.key === "Enter") {
    }

    if (e.ctrlKey && e.key === "Enter") {
    }

    if (e.altKey && e.key === "Enter") {
    }

    // Detect double key press (same key within 400ms)
    if (lastKey.current === e.key && now - lastKeyPressTime.current < 400) {
    }

    lastKey.current = e.key;
    lastKeyPressTime.current = now;
  };

  const handleDownload = async () => {
    try {
      const _data = {
        collectionId: [Data?.collectionID],
      };
      const res = await startDownload(_data);

    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Fragment>
      <div
        key={Index}
        tabIndex={Index} // Makes the div focusable for key events
        className={`dam_common_hover ${isSelected && "dam_selected_design"}`}
        style={{ position: "relative" }}
        onClick={handleMouseClick} // Mouse click
        onDoubleClick={handleDoubleClick} // Mouse double click
        onKeyDown={handleKeyDown} // Keyboard + double key detection
      >
        <div
          className="image_container_2nd_version_image_section"
          style={{
            backgroundImage: `url(${Data?.thumbNailPath?.[0]})`,
            backgroundSize: "cover",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            margin: "16px",
          }}
          className="collection_size_continer"
        >
          {CommonSvg.collectionNumberAssetSvgIcon}{" "}
          <span
            className="collection_size_design"
            style={{
              marginLeft: "4px",
            }}
          >
            {Data?.totalAssetSize}
          </span>
        </div>

        <div
          style={{
            padding: "16px",
            display: "flex",
            justifyContent: "space-between",
            bottom: 0,
            width: "100%",
            borderRadius: "0px 0px 8px 8px",
            alignItems: "center",
          }}
        >
          <div className="d-flex gap-2 align-items-center">
            {CommonSvg.collectionPreviewIcon}{" "}
            <div>
              <div className="image_container_2nd_version_image_section_2nd_header d-flex">
                <WordWrapEllipse
                  Text={Data?.collection_name}
                  MaxWidth={"18ch"}
                  showTooltip={false}
                />
              </div>
              <div className="image_container_2nd_version_image_section_2nd_description">
                Created By {Data?.createdBy}
              </div>
            </div>
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              handleDownload();
            }}
            onDoubleClick={(e) => e.stopPropagation()} // stop double-click bubbling
            onKeyDown={(e) => e.stopPropagation()} // stop key events bubbling
          >
            {EllipseActions}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CommonCollection;
